import { create } from 'zustand';

interface CartStore {
  cartItemsCount: number;
  setCartItemsCount: (count: number) => void;
  updateCartCount: () => Promise<void>;
}

export const useCartStore = create<CartStore>((set) => ({
  cartItemsCount: 0,
  setCartItemsCount: (count) => set({ cartItemsCount: count }),
  updateCartCount: async () => {
    try {
      const { getCart } = await import('../requests/cart/cart');
      const response = await getCart();
      const items = response.items || [];
      set({ cartItemsCount: items.length });
    } catch (error) {
      console.error(
        'Ошибка при обновлении количества товаров в корзине:',
        error,
      );
    }
  },
}));
